import { createFileRoute } from '@tanstack/react-router';
import { TeamsPage } from '../../../features/access/DirectoryPages';
export const Route = createFileRoute('/_settings/settings/teams')({ component: TeamsPage });
